module.exports = __webpack_public_path__ + "20230117/img/slide2_diannao.4f1a85f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slide2_diannao.png
// module id = cGzi
// module chunks = 1